import logo from '../../assets/img/AO_REWARDS.png';
import './styles.scss';
import {Link, useLocation, useNavigate} from 'react-router-dom';

export  const Sidebar = ({role, mobileMenuIsOpen}) => {
    const navigate = useNavigate();
    const location = useLocation();

    function isActive(page) {
        if ((location.pathname === '/' || location.pathname === '') && page === '/dashboard') {
            return 'active';
        }

        return page === location.pathname ? 'active' : '';
    }

    return (
        <aside className={"sidebar desktop-hidden " + (mobileMenuIsOpen ? 'active' : '')}>
            <img src={logo} alt="logo" className="logo" onClick={() => {
                navigate('/dashboard');
            }} />

            <ul className="nav-items">
                <li>
                    <Link to="/dashboard"
                          className={'nav-item ' + isActive('/dashboard')}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none"
                             className="icon">
                            <path
                                d="M13.5 21V11H21.5V21H13.5ZM3.5 13V3H11.5V13H3.5ZM9.5 11V5H5.5V11H9.5ZM3.5 21V15H11.5V21H3.5ZM5.5 19H9.5V17H5.5V19ZM15.5 19H19.5V13H15.5V19ZM13.5 3H21.5V9H13.5V3ZM15.5 5V7H19.5V5H15.5Z"
                                fill="#667085"/>
                        </svg>
                        Dashboard
                    </Link>
                </li>
                {role === 'distributor' && (
                    <li>
                        <Link to="/statements"
                              className={"nav-item " + isActive('/statements')}>
                            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                                 className="icon">
                                <g id="instance-line">
                                    <path id="Vector"
                                          d="M5 7.65311V16.3469L12.5 20.689L20 16.3469V7.65311L12.5 3.311L5 7.65311ZM12.5 1L22 6.5V17.5L12.5 23L3 17.5V6.5L12.5 1ZM6.99896 9.97065L11.5 12.5765V17.625H13.5V12.5765L18.001 9.97066L16.999 8.2398L12.5 10.8445L8.00104 8.2398L6.99896 9.97065Z"
                                          fill="#667085"/>
                                </g>
                            </svg>
                            Statements
                        </Link>
                    </li>
                )}

                {role === 'contractor' && (
                    <>
                        <li>
                            <Link to="/products"
                                  className={"nav-item " + isActive('/products')}>
                                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                                     className="icon">
                                    <g id="instance-line">
                                        <path id="Vector"
                                              d="M5 7.65311V16.3469L12.5 20.689L20 16.3469V7.65311L12.5 3.311L5 7.65311ZM12.5 1L22 6.5V17.5L12.5 23L3 17.5V6.5L12.5 1ZM6.99896 9.97065L11.5 12.5765V17.625H13.5V12.5765L18.001 9.97066L16.999 8.2398L12.5 10.8445L8.00104 8.2398L6.99896 9.97065Z"
                                              fill="#667085"/>
                                    </g>
                                </svg>
                                Products
                            </Link>
                        </li>

                        <li>
                            <Link to="/statements"
                                  className={"nav-item " + isActive('/statements')}>
                                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                                     className="icon">
                                    <g id="instance-line">
                                        <path id="Vector"
                                              d="M5 7.65311V16.3469L12.5 20.689L20 16.3469V7.65311L12.5 3.311L5 7.65311ZM12.5 1L22 6.5V17.5L12.5 23L3 17.5V6.5L12.5 1ZM6.99896 9.97065L11.5 12.5765V17.625H13.5V12.5765L18.001 9.97066L16.999 8.2398L12.5 10.8445L8.00104 8.2398L6.99896 9.97065Z"
                                              fill="#667085"/>
                                    </g>
                                </svg>
                                Statements
                            </Link>
                        </li>

                        <li>
                            <Link to="/past-rewards"
                                  className={"nav-item " + isActive('/past-rewards')}>
                                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                                     className="icon">
                                    <g id="medal-line">
                                        <path id="Vector"
                                              d="M12.5 7.00002C16.9183 7.00002 20.5 10.5817 20.5 15C20.5 19.4183 16.9183 23 12.5 23C8.08172 23 4.5 19.4183 4.5 15C4.5 10.5817 8.08172 7.00002 12.5 7.00002ZM12.5 9.00002C9.18629 9.00002 6.5 11.6863 6.5 15C6.5 18.3137 9.18629 21 12.5 21C15.8137 21 18.5 18.3137 18.5 15C18.5 11.6863 15.8137 9.00002 12.5 9.00002ZM12.5 10.5L13.8225 13.1797L16.7798 13.6094L14.6399 15.6953L15.145 18.6406L12.5 17.25L9.85497 18.6406L10.3601 15.6953L8.22025 13.6094L11.1775 13.1797L12.5 10.5ZM18.5 2.00002V5.00002L17.1366 6.13758C16.0305 5.55773 14.8025 5.17887 13.5011 5.04951L13.5 1.99902L18.5 2.00002ZM11.5 1.99902L11.4997 5.04943C10.1984 5.17866 8.97046 5.55738 7.86441 6.13706L6.5 5.00002V2.00002L11.5 1.99902Z"
                                              fill="#667085"/>
                                    </g>
                                </svg>
                                Past Rewards
                            </Link>
                        </li>
                    </>
                )}

                <li>
                    <Link to="/account-settings"
                          className={"nav-item " + isActive('/account-settings')}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none"
                             className="icon">
                            <path
                                d="M2.5 11.9998C2.5 11.1353 2.6097 10.2964 2.81595 9.49631C3.90622 9.55283 4.98848 9.01015 5.5718 7.99982C6.15467 6.99025 6.08406 5.78271 5.49121 4.86701C6.68354 3.69529 8.16832 2.82022 9.82603 2.36133C10.3222 3.33385 11.3333 3.99982 12.5 3.99982C13.6667 3.99982 14.6778 3.33385 15.174 2.36133C16.8317 2.82022 18.3165 3.69529 19.5088 4.86701C18.9159 5.78271 18.8453 6.99025 19.4282 7.99982C20.0115 9.01015 21.0938 9.55283 22.1841 9.49631C22.3903 10.2964 22.5 11.1353 22.5 11.9998C22.5 12.8643 22.3903 13.7032 22.1841 14.5033C21.0938 14.4468 20.0115 14.9895 19.4282 15.9998C18.8453 17.0094 18.9159 18.2169 19.5088 19.1326C18.3165 20.3043 16.8317 21.1794 15.174 21.6383C14.6778 20.6658 13.6667 19.9998 12.5 19.9998C11.3333 19.9998 10.3222 20.6658 9.82603 21.6383C8.16832 21.1794 6.68354 20.3043 5.49121 19.1326C6.08406 18.2169 6.15467 17.0094 5.5718 15.9998C4.98848 14.9895 3.90622 14.4468 2.81595 14.5033C2.6097 13.7032 2.5 12.8643 2.5 11.9998ZM7.30385 14.9998C7.93395 16.0912 8.11458 17.3459 7.86818 18.5236C8.27597 18.8138 8.71005 19.0652 9.16489 19.2741C10.0618 18.4712 11.2392 17.9998 12.5 17.9998C13.7608 17.9998 14.9382 18.4712 15.8351 19.2741C16.2899 19.0652 16.724 18.8138 17.1318 18.5236C16.8854 17.3459 17.066 16.0912 17.6962 14.9998C18.3262 13.9085 19.3225 13.1248 20.4655 12.7493C20.4884 12.5015 20.5 12.2516 20.5 11.9998C20.5 11.7481 20.4884 11.4981 20.4655 11.2504C19.3225 10.8749 18.3262 10.0912 17.6962 8.99982C17.066 7.90845 16.8854 6.65378 17.1318 5.47605C16.724 5.18588 16.2899 4.93447 15.8351 4.72552C14.9382 5.52844 13.7608 5.99982 12.5 5.99982C11.2392 5.99982 10.0618 5.52844 9.16489 4.72552C8.71005 4.93447 8.27597 5.18588 7.86818 5.47605C8.11458 6.65378 7.93395 7.90845 7.30385 8.99982C6.67376 10.0912 5.67754 10.8749 4.53451 11.2504C4.51157 11.4981 4.5 11.7481 4.5 11.9998C4.5 12.2516 4.51157 12.5015 4.53451 12.7493C5.67754 13.1248 6.67376 13.9085 7.30385 14.9998ZM12.5 14.9998C10.8431 14.9998 9.5 13.6567 9.5 11.9998C9.5 10.343 10.8431 8.99982 12.5 8.99982C14.1569 8.99982 15.5 10.343 15.5 11.9998C15.5 13.6567 14.1569 14.9998 12.5 14.9998ZM12.5 12.9998C13.0523 12.9998 13.5 12.5521 13.5 11.9998C13.5 11.4475 13.0523 10.9998 12.5 10.9998C11.9477 10.9998 11.5 11.4475 11.5 11.9998C11.5 12.5521 11.9477 12.9998 12.5 12.9998Z"
                                fill="#667085"/>
                        </svg>
                        Account Settings
                    </Link>
                </li>

                <li style={{paddingLeft: 31}}>
                    <Link to="/logout"
                          className={"nav-item"}>
                        Logout
                    </Link>
                </li>
            </ul>
        </aside>
    )
}
